export const ADD_PROFILE_SUCCESS = "ADD_PROFILE_SUCCESS";
